import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from "react-router-dom";
import Header from "./Header";
export default function Layout({ children }) {
    const location = useLocation();
    // 直接基于 location.pathname 计算，无需额外状态
    const isLoginPage = location.pathname === "/login";
    // 根据路径设置背景（直接使用 location.pathname）
    const getBgClassName = () => {
        if (isLoginPage)
            return "login-bg";
        switch (location.pathname) {
            case "/common":
                return "common-bg";
            case "/eam":
                return "eam-bg";
            case "/uam":
                return "uam-bg";
            case "/lcg":
                return "lcg-bg";
            case "/cpm":
                return "cpm-bg";
            default:
                return "";
        }
    };
    return (_jsxs("div", { className: `text-white flex flex-col min-h-screen size-full ${getBgClassName()}`, children: [!isLoginPage && _jsx(Header, {}), _jsx("main", { className: "flex-1 overflow-auto flex min-h-0", children: children })] }));
}
